<app-card-header [header]="header"></app-card-header>
<app-cd003-card-II (mkCalc)="makeCalculations($event)" (getDados)="getDadosMateriaPrima()"></app-cd003-card-II>
<br>
<app-cd003-card-I (objCd001)="getCd001Data($event)" (mkCalc)="makeCalculations($event)"
  (objQua007)="getDataQua007bySafra($event)" (objPC003)="getPC003Data($event)" (getDados)="getDadosMateriaPrima()"></app-cd003-card-I>
<br>
<app-cd003-card-III (mkCalc)="makeCalculations($event)"></app-cd003-card-III>
<br>
<app-cd003-card-IV (makeCalcII)="mkCalcII($event)" (mkCalc)="makeCalculations($event)" (mkEditButton)="makeEditBtn($event)"></app-cd003-card-IV>
<br>
<app-cd003-card-V (mkCalc)="makeCalculations($event)"></app-cd003-card-V>
<br>
<app-cd003-card-VI (mkCalc)="makeCalculations($event)"></app-cd003-card-VI>
<br>
<app-cd003-card-VII (mkCalc)="makeCalculations($event)"></app-cd003-card-VII>
<br>
<app-cd003-card-VIII (mkCalc)="makeCalculations($event)"></app-cd003-card-VIII>
<br>
<app-cd003-card-IX (mkCalc)="makeCalculations($event)"></app-cd003-card-IX>
<br>



<div class="row">
  <div class="col-lg col-md col-xs col-sm col-xl cardAction text-right">
    <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Voltar"
      [routerLink]="['/formcd003']">
      <i class="fa fa-undo fa-1x btnIcon"></i> Voltar
    </button>
    <ng-container *ngIf="!btnCollapse">
      <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Maximizar"
        (click)="collapseAll()">
        <i class="fa fa-window-maximize fa-1x btnIcon"></i> Maximizar
      </button>
    </ng-container>
    <ng-container *ngIf="btnCollapse">
      <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Minimizar"
        (click)="collapseAll()">
        <i class="fa fa-window-minimize fa-1x btnIcon"></i> Minimizar
      </button>
    </ng-container>
    <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Limpar" (click)="cleanAll()"
      [hidden]="!enableButtons | async">
      <i class="fa fa-paint-brush fa-1x btnIcon"></i> Limpar
    </button>
    <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Salvar" (click)="save()"
      [hidden]="!enableButtons | async">
      <i class="fa fa-floppy-o fa-1x btnIcon"></i> Salvar
    </button>
  </div>
</div>
